export default "__VITE_ASSET__BIw07v2b__"